import React from "react";

const Java_If = () => {
  return (
    <div>
      <h1>Java If</h1>
      <p>This page provides explanations, examples, and common use-cases for Java If in Java.</p>
    </div>
  );
};

export default Java_If;
